import { Icon, Tooltip } from '@/components/ui';
import { Box } from '@chakra-ui/react';

import cn from 'classnames';
import React from 'react';
import styles from '../controls.module.sass';

interface Props {
  muted: boolean;
  isShowTitle?: boolean;
  isLightMode?: boolean;
  lightMode?: boolean;
  muteTitle?: string;
  unmuteTitle?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const Mute = (props: Props) => {
  //
  const {
    muted = false,
    muteTitle = 'Mute',
    unmuteTitle = 'Unmute',
    isShowTitle = true,
    isLightMode = false,
    onClick,
  } = props;

  return (
    <Tooltip
      label={muted ? unmuteTitle : muteTitle}
      isDisabled={!isShowTitle}
      variant={isLightMode && 'white'}
    >
      <Box
        className={cn(styles.Button, isLightMode && styles.isLightMode)}
        onClick={onClick}
      >
        <Icon icon={muted ? 'sound-off' : 'sound-on'} className={styles.Icon} />
      </Box>
    </Tooltip>
  );
};
